<template>
  <div class = "gradeCalcPage">
    <div class ="logos">
      <img src=".././assets/loyola.png">
      <br>
      <img src=".././assets/northwestern.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'gradeCalcPage',
  
}
</script>

<style scoped>

.logos{
  margin-top:100px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// GradeCalcPage.vue?0305ee84